export function alphaNumericKeysOnly(event): boolean {
	// Allow control keys
	if (event.ctrlKey || event.metaKey || event.altKey) {
		return true;
	}
	const key = event.key;
	// Allow navigation/control keys (Backspace, Delete, Tab, arrows, etc.)
	if (key.length > 1) {
		return true;
	}
	// Allow only letters and digits
	if (/^[a-zA-Z0-9]$/.test(key)) {
		return true;
	}
	event.preventDefault();
	return false;
}
